import { render, staticRenderFns } from "./trans_d_over.vue?vue&type=template&id=db761cec"
import script from "./trans_d_over.vue?vue&type=script&lang=js"
export * from "./trans_d_over.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports